<template>
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical form">
    <Form @submit="onBeforeSubmit" :validation-schema="validationSchema" ref="form" :initial-values="formValues">
      <div class="uk-modal-header form-header">
        <span class="uk-text-bold uk-text-large">{{ user && user.id ? "ユーザー編集" : "ユーザー新規追加" }}</span>
      </div>
      <div class="uk-modal-body">
        <FormError :errors="globalErrors" />
        <div class="field">
          <Field name="username" v-slot="{ field }">
            <FieldLabel title="ユーザーID" :required="true" />
            <span>&ensp;(重複するIDは登録できません)</span>
            <input class="uk-input" type="text" v-bind="field" placeholder="example@hyoumanbox.com" :readonly="user && user.id" />
          </Field>
          <FieldError name="username" />
        </div>
        <div class="field column-2">
          <div>
            <Field name="lastName" v-slot="{ field }">
              <FieldLabel title="姓" :required="true" />
              <input class="uk-input" type="text" v-bind="field" />
            </Field>
            <FieldError name="lastName" />
          </div>
          <div>
            <Field name="firstName" v-slot="{ field }">
              <FieldLabel title="名" :required="true" />
              <input class="uk-input" type="text" v-bind="field" />
            </Field>
            <FieldError name="firstName" />
          </div>
        </div>
        <div class="field">
          <Field name="email" v-slot="{ field }">
            <FieldLabel title="メールアドレス" :required="true" />
            <input class="uk-input" type="text" v-bind="field" />
          </Field>
          <FieldError name="email" />
        </div>
        <div class="field">
          <FieldLabel title="権限" :required="true" />
          <Field name="role" v-slot="{ field }">
            <select class="uk-select" v-bind="field">
              <option v-for="role in roles" :key="role.value" :value="role.value">{{ role.name }}</option>
            </select>
          </Field>
          <FieldError name="role" />
        </div>
      </div>
      <div class="uk-modal-footer uk-text-right form-action">
        <div>
          <ActionButton title="戻る" class="uk-modal-close" toggleTarget=".user-form-modal" />
        </div>
        <div class="form-action-main">
          <ActionButton title="完了" color="primary" type="submit" :disabled="processing" />
          <ActionButton v-if="user" title="削除" @click="onDeleteButtonClick" color="warn" />
        </div>
      </div>
    </Form>
  </div>
</template>
<style lang="scss" scoped>
@include modal-form;
</style>
<script lang="ts">
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import FormMixin from "../../helpers/mixins/form";
import { User, UserApi } from "../../autogen";
import { Field, Form } from "vee-validate";
import FieldLabel from "../atoms/FieldLabel.vue";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
type FormValues = {
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
};
@Options({
  components: { Field, Form, FieldLabel, FieldError, ActionButton, FormError }
})
export default class UserForm extends FormMixin {
  @Prop({ type: Object }) user?: User;
  formName = "ユーザー";
  formValues: Partial<FormValues> = {};
  validationSchema!: yup.AnyObjectSchema;

  beforeCreate() {
    this.validationSchema = yup.object({
      username: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "ユーザーID" })),
      firstName: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "名" })),
      lastName: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "姓" })),
      email: yup
        .string()
        .required(this.$t("input_required", { field: "メールアドレス" }))
        .email(this.$t("input_email")),
      password: yup.string().required(),
      role: yup.string().required(this.$t("input_required", { field: "権限" }))
    });
  }

  async beforeMount() {
    await this.setRoles();
    if (this.user) {
      Object.assign(this.formValues, this.user);
    } else {
      this.formValues = {
        username: "",
        firstName: "",
        lastName: "",
        email: "",
        role: "2"
      };
    }
  }
  async onBeforeSubmit(formValues: FormValues) {
    await this.onSubmit(async () => {
      if (this.user) {
        await new UserApi().updateUser({
          clientId: this.$route.params.clientId as string,
          userId: this.user.id,
          updateUserRequest: formValues
        });
      } else {
        await new UserApi().createUser({
          clientId: this.$route.params.clientId as string,
          createUserRequest: formValues
        });
      }
      this.$emit("submitted");
    });
  }
  async onDeleteButtonClick() {
    this.onDelete(async () => {
      await new UserApi().deleteUser({
        clientId: this.$route.params.clientId as string,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        userId: this.user!.id
      });
    }, "従業員を削除します。よろしいでしょうか？\n※削除した場合、従業員は完全に削除されます。\n※適性検査のデータも全て表示されなくなります。");
  }
}
</script>
